<div class="rsd-overlay" [class.open]="open" (click)="onClose()"></div>
<aside class="rsd" [class.open]="open" [style.width]="width"
       role="dialog" aria-modal="true" [attr.aria-hidden]="!open">
  <div class="rsd-head">
    <div class="rsd-head-text">
      <h3 class="rsd-title">{{ title }}</h3>
      <p class="rsd-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button class="rsd-close" type="button" (click)="onClose()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="rsd-body">
    <ng-content></ng-content>
  </div>

  <div class="rsd-foot" *ngIf="footer">
    <ng-content select="[drawer-footer]"></ng-content>
  </div>
</aside>
